import markup from './certification-logos.component.html?raw';
import styles from './certification-logos.component.scss?inline';

const template = document.createElement('template');
template.innerHTML = `
  <style>${styles}</style>
  ${markup}
`;

class CertificationLogosElement extends HTMLElement {
  private readonly root: ShadowRoot;

  public constructor() {
    super();

    // Initialize shadow DOM once so internal logic can use a non-null root.
    this.root = this.attachShadow({ mode: 'open' });
    this.root.appendChild(template.content.cloneNode(true));
  }

  /**
   *
   */
  static get observedAttributes(): string[] {
    return ['template-directory'];
  }

  /**
   *
   */
  public attributeChangedCallback(name: string, _oldValue: string | null, newValue: string | null): void {
    if (name === 'template-directory') {
      // Update the image sources in the template with the new template directory.
      const images = this.root.querySelectorAll('img[data-src]');
      for (const img of images) {
        const dataSrc = img.getAttribute('data-src') ?? '';
        img.setAttribute('src', `${newValue || ''}${dataSrc}`);
      }
    }
  }
}

if (!customElements.get('certification-logos')) {
  customElements.define('certification-logos', CertificationLogosElement);
}
